<template>
  <el-popover width="240" placement="bottom" trigger="hover" transition="popover-fade-in-out-fast">
    <div slot="reference" class="reference-box">
      <SvgIcon iconClass="iconsaoma" />
      <span>移动端</span>
    </div>
    <div class="qrcode-box">
      <img src="@/assets/images/header/appEenterence-qrcode.png" />
      <span>浙里掌上贷，操作更便捷</span>
    </div>
  </el-popover>
</template>

<script>
import SvgIcon from '../../SvgIcon.vue'
export default {
  components: {
    SvgIcon
  }
}
</script>

<style lang="scss" scoped>
.reference-box {
  display: flex;
  align-items: center;
  cursor: pointer;
  outline: none;
  font-size: 20px;

  .svg-icon {
    font-size: 24px;
  }

  span {
    font-weight: 400;
    color: $main-color;
    margin: 0 8px;
    line-height: 1;
  }
}

.qrcode-box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 15px;
  font-size: 20px;

  img {
    width: 150px;
    height: 150px;
  }
  span {
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 1;
  }
}
</style>

<style>
.popover-fade-in-out-fast-enter,
.popover-fade-in-out-fast-leave-to {
  opacity: 0;
}
.popover-fade-in-out-fast-enter-to,
.popover-fade-in-out-fast-leave {
  opacity: 1;
}
.popover-fade-in-out-fast-enter-active,
.popover-fade-in-out-fast-leave-active {
  transition: all 0.15s ease-in-out;
}
</style>
